export default __webpack_public_path__ + "static/media/Xbox.048abf3b.svg";